module.exports = __webpack_public_path__ + "static/media/SharpSansNo1-Light.e82e9403.woff";